import { toArray, startsWith, toLower, includes } from 'lodash';

import { cleanQuery } from '../search/utils';

export const getPartner = (state, id) => {
    if (!id || id < 1) {
        return null;
    }
    return state.partner.partners[id] ? state.partner.partners[id] : null;
};

export const getEbonPartner = (state, id) => {
    if (!id || id < 1) {
        return null;
    }

    const ebonPartner = state.ebon.ebonPartners.filter(p => p.id === id);

    return ebonPartner.length > 0 ? ebonPartner[0] : null;
};

export const getOfflinePartnerByMoId = (state, moId) => {
    if (!moId || moId < 1) {
        return null;
    }
    return state.partner.offlinePartners[moId] ? state.partner.offlinePartners[moId] : null;
};

export const isBoost = partner =>
    partner.mostDisplayableDiscountOnline &&
    (partner.mostDisplayableDiscountOnline.initialFixed > 0 ||
        partner.mostDisplayableDiscountOnline.initialPercent > 0);

export const getBoostPartners = state => toArray(state.partner.partners).filter(p => isBoost(p));

export const filterPartnerNameStartsWith = (state, target) =>
    !!target
        ? toArray(state.partner.partners)
              .filter(p => includes(cleanQuery(p.name), cleanQuery(target)))
              .sort((a, b) => {
                  const ia = a.name.toLowerCase().indexOf(cleanQuery(target));
                  const ib = b.name.toLowerCase().indexOf(cleanQuery(target));

                  if (ia === ib) {
                      return a.name > b.name;
                  }

                  if (ia === -1) {
                      return 1;
                  }

                  if (ib === -1) {
                      return -1;
                  }

                  return ia - ib;
              })
        : [];

export const sortOnOrder = (p1, p2) => p1.turnoverEbcOrder - p2.turnoverEbcOrder;

export const sortOnCreationDate = (p1, p2) => p2.creationDate - p1.creationDate;

export const sortOnNbCoupon = (p1, p2) => {
    if (p1.couponCount === p2.couponCount) {
        return p1.turnoverEbcOrder - p2.turnoverEbcOrder;
    }
    return p2.couponCount - p1.couponCount;
};

export const sortOnCashback = (p1, p2) => {
    if (!p1.mostDisplayableDiscountOnline || !p2.mostDisplayableDiscountOnline) {
        return null;
    }

    const pc1 = p1.mostDisplayableDiscountOnline.percent;
    const pc2 = p2.mostDisplayableDiscountOnline.percent;
    // sort by percent discount first
    if (pc1 > 0 || pc2 > 0) {
        // sort by discount desc or order asc
        return pc1 !== pc2 ? pc2 - pc1 : p1.turnoverEbcOrder - p2.turnoverEbcOrder;
    }

    const f1 = p1.mostDisplayableDiscountOnline.fixed;
    const f2 = p2.mostDisplayableDiscountOnline.fixed;
    // if no percent, sort by fixed discount
    if (f1 > 0 || f2 > 0) {
        return f1 !== f2 ? f2 - f1 : p1.turnoverEbcOrder - p2.turnoverEbcOrder;
    }
};

export const sortOnCashbackOffline = (p1, p2) => {
    if (!p1.mostDisplayableDiscountOffline || !p2.mostDisplayableDiscountOffline) {
        return null;
    }

    const pc1 = p1.mostDisplayableDiscountOffline.percent;
    const pc2 = p2.mostDisplayableDiscountOffline.percent;
    // sort by percent discount first
    if (pc1 > 0 || pc2 > 0) {
        // sort by discount desc or order asc
        return pc1 !== pc2 ? pc2 - pc1 : p1.turnoverEbcOrder - p2.turnoverEbcOrder;
    }

    const f1 = p1.mostDisplayableDiscountOffline.fixed;
    const f2 = p2.mostDisplayableDiscountOffline.fixed;
    // if no percent, sort by fixed discount
    if (f1 > 0 || f2 > 0) {
        return f1 !== f2 ? f2 - f1 : p1.turnoverEbcOrder - p2.turnoverEbcOrder;
    }
};

export const sortOnCashbackEbon = (p1, p2) => {
    if (
        !(p1.ebonDiscount && p1.ebonDiscount.cashback) ||
        !(p2.ebonDiscount && p2.ebonDiscount.cashback)
    ) {
        return null;
    }

    const pc1 = p1.ebonDiscount.cashback.percent.value;
    const pc2 = p2.ebonDiscount.cashback.percent.value;
    // sort by percent discount first
    if (pc1 > 0 || pc2 > 0) {
        // sort by discount desc or order asc
        return pc1 !== pc2 ? pc2 - pc1 : p1.order - p2.order;
    }

    const f1 = p1.ebonDiscount.cashback.fixed.value;
    const f2 = p2.ebonDiscount.cashback.fixed.value;
    // if no percent, sort by fixed discount
    if (f1 > 0 || f2 > 0) {
        return f1 !== f2 ? f2 - f1 : p1.order - p2.order;
    }
};

export const sortOnName = (p1, p2) => toLower(p1.name).localeCompare(toLower(p2.name));

export const filterOnCategory = categoryId => partner =>
    partner &&
    partner.categoriesIds &&
    Array.isArray(partner.categoriesIds) &&
    partner.categoriesIds.includes(categoryId);

export const filterOnCategoryEbon = categoryId => partner =>
    partner &&
    partner.categories &&
    Array.isArray(partner.categories) &&
    partner.categories.includes(categoryId);

export const filterOnFirstLetter = letter => partner =>
    partner && partner.name && partner.name.length > 0 && letter === '123'
        ? toLower(partner.name).match(/^\d/)
        : startsWith(toLower(partner.name), letter);



// WEBPACK FOOTER //
// ./src/services/partner/selector.js